module.exports = __webpack_public_path__ + "files/3fe9fdc9daa88314465f29cd6eadc2c9.png";